const requireModule = import.meta.glob('@/assets/js/src/modules/**/_routes/index.js', {eager: true,})

export default () => requireModule
